/**
 * French language translations.
 * Format: {'property': 'translation value';}
 */
export const LANG_FR_TRANS = {
    // menu
    'lvt.menu.twroute': 'Routes',
    'lvt.menu.twcalloff': 'twCalloff',
    'lvt.menu.twslot': 'twSlot',
    'lvt.menu.slot_booking': 'Smart Booking',
    'lvt.menu.twdoc': 'twDoc',
    'lvt.menu.twcost': 'twCost',
    'lvt.menu.lvt': 'Live Tracking',
    'lvt.menu.app_name': 'Transwide',
    'lvt.menu.my_profile': 'Mon profil',
    'lvt.menu.tw_profile': 'Profil TW',
    'lvt.menu.company_profile': 'Ma société',
    'lvt.menu.my_notifications': 'Mes notifications',
    'lvt.menu.sign_out': 'Se déconnecter',

    // footer
    'lvt.footer.back_to_top': 'Retour au début',
    'lvt.footer.terms_of_use': 'Conditions d\'utilisation',
    'lvt.footer.privacy_policy': 'Politique de confidentialité',
    'lvt.footer.support_information': 'Informations de support',
    'lvt.footer.transwide_home': 'Accueil Transwide',
    'lvt.footer.license_nr': 'N° de licence :',
    'lvt.footer.build_version': 'Version :',

    // order list columns
    'lvt.order_list.header': 'Liste d\'ordres',
    'lvt.order_list.column.shipperCompany': 'Chargeur',
    'lvt.order_list.column.reference': 'Référence',
    'lvt.order_list.column.status': 'Statut',
    'lvt.order_list.column.statusReason': 'Motif du statut',
    'lvt.order_list.column.senderCompany': 'Expéditeur',
    'lvt.order_list.column.senderZipcode': 'Code postal expéditeur',
    'lvt.order_list.column.senderCity': 'Ville expéditeur',
    'lvt.order_list.column.receiverCompany': 'Destinataire',
    'lvt.order_list.column.receiverZipcode': 'Code postal destinataire',
    'lvt.order_list.column.receiverCity': 'Ville destinataire',
    'lvt.order_list.column.carrierName': 'Nom du transporteur',
    'lvt.order_list.column.plannedPickupEndDate': 'Enlèvement prévu',
    'lvt.order_list.column.etaPickup': 'ETA au chargement',
    'lvt.order_list.column.delayAtPickup': 'Retard au chargement',
    'lvt.order_list.column.plannedDeliveryEndDate': 'Livraison prévue',
    'lvt.order_list.column.etaDelivery': 'ETA à la livraison',
    'lvt.order_list.column.delayAtDelivery': 'Retard à la livraison',
    'lvt.order_list.column.timestamps': 'Horodatage',
    'lvt.order_list.column.bookingPickupTime': 'Booking pickup',
    'lvt.order_list.column.bookingDeliveryTime': 'Booking delivery',

    // status order list
    'lvt.order_list.status.requested': 'Demandé',
    'lvt.order_list.status.failed': 'Erreur',
    'lvt.order_list.status.waiting': 'En attente',
    'lvt.order_list.status.active': 'Actif',
    'lvt.order_list.status.stopped': 'Erreur',
    'lvt.order_list.status.completed': 'Terminé',
    'lvt.order_list.status.cancelled': 'Annulé',
    'lvt.order_list.status.timeout': 'Expiré',

    // status reason order list
    'lvt.order_list.status_reason.carrier_not_assigned': 'Transporteur non attribué',
    'lvt.order_list.status_reason.plate_number_not_present': 'Plaque d\'immatriculation non présente',
    'lvt.order_list.status_reason.plate_number_not_recognized': 'Plaque d\'immatriculation non reconnue',
    'lvt.order_list.status_reason.plate_number_not_operational': 'Plaque d\'immatriculation non opérationnelle',
    'lvt.order_list.status_reason.technical_error_not_posted': 'Technical error when creating the tour in GH',

    // pagination
    'lvt.order_list.pagination.rows_per_page': 'lignes par page',
    'lvt.order_list.pagination.first': 'Premier',
    'lvt.order_list.pagination.previous': 'Précédent',
    'lvt.order_list.pagination.next': 'Suivant',
    'lvt.order_list.pagination.last': 'Dernier',
    'lvt.order_list.pagination.no_orders_found': 'Aucun ordre trouvé',

    // tracked device
    'lvt.map.tracked_device.trailer': 'Remorque',
    'lvt.map.tracked_device.tractor': 'Tracteur',
    'lvt.map.tracked_device.mobile': 'Téléphone portable',

    // map
    'lvt.map.button.open_settings': 'Open settings',
    'lvt.map.button.open_order_list': 'Liste des ordres ouverts',
    'lvt.map.traffic_information.traffic': 'Traffic',
    'lvt.map.traffic_information.fast': 'Fast',
    'lvt.map.traffic_information.slow': 'Slow',
    'lvt.map.pickup_popup.pickup': 'Chargement',
    'lvt.map.pickup_popup.date': 'Date',
    'lvt.map.pickup_popup.address': 'Adresse',
    'lvt.map.delivery_popup.delivery': 'Livraison',
    'lvt.map.delivery_popup.date': 'Date',
    'lvt.map.delivery_popup.address': 'Adresse',
    'lvt.map.current_gps_popup.in_transit_to_at_delivery': 'En transit pour livraison',
    'lvt.map.current_gps_popup.in_transit_to_at_pickup': 'En transit pour chargement',
    'lvt.map.current_gps_popup.current_speed': 'Vitesse actuelle',
    'lvt.map.current_gps_popup.average_speed': 'Vitesse moyenne',
    'lvt.map.current_gps_popup.last_location_update': 'Dernière mise à jour de la position',
    'lvt.map.current_gps_popup.eta': 'ETA',
    'lvt.map.current_gps_popup.planned_time': 'Heure prévue',
    'lvt.map.current_gps_popup.arrival_delay': 'Retard à l\'arrivée',
    'lvt.map.current_gps_popup.speed_unit': 'km/h',

    // timestamps
    'lvt.order_list.timestamp.arrived_at_origin': 'Arrivé au point d\'origine',
    'lvt.order_list.timestamp.not_arrived_at_origin': 'Pas arrivé au point d\'origine',
    'lvt.order_list.timestamp.left_origin': 'A quitté le point d\'origine',
    'lvt.order_list.timestamp.not_left_origin': 'N\'a pas quitté le point d\'origine',
    'lvt.order_list.timestamp.arrived_at_destination': 'Arrivé à destination',
    'lvt.order_list.timestamp.not_arrived_at_destination': 'Pas arrivé à destination',
    'lvt.order_list.timestamp.left_destination': 'A quitté la destination',
    'lvt.order_list.timestamp.not_left_destination': 'N\'a pas quitté la destination',

    // settings
    'lvt.settings.header': 'Settings',
    'lvt.settings.delay_management': 'Delay management',
    'lvt.settings.add_new': 'Add new +',
    'lvt.settings.column.ruleTitle': 'Rule title',
    'lvt.settings.column.type': 'Type',
    'lvt.settings.column.offset': 'Offset',
    'lvt.settings.column.actions': 'Actions',
    'lvt.settings.create_rule': 'Create rule',
    'lvt.settings.view_rule': 'View rule',
    'lvt.settings.go_back_to_list': 'Go back to list',
    'lvt.settings.edit_rule': 'Modify rule',
    'lvt.settings.delete_rule': 'Delete rule',
    'lvt.settings.delete_this_rule': 'Delete this rule',
    'lvt.settings.rule_type.delay': 'Delay',
    'lvt.settings.rule_type.at_risk': 'At risk',
    'lvt.settings.no_rules_found': 'No rules found',
    'lvt.settings.delete_popup.message': 'Are you sure you want to delete this rule?',
    'lvt.settings.field.rule_title': 'Rule title',
    'lvt.settings.field.location_type': 'Location type',
    'lvt.settings.field.location_type_pickup': 'Pickup',
    'lvt.settings.field.location_type_delivery': 'Delivery',
    'lvt.settings.field.rule_type': 'Rule type',
    'lvt.settings.field.rule_type_delay.time_offset': 'Time offset threshold',
    'lvt.settings.field.rule_type_delay.unit_minutes': 'Minutes',
    'lvt.settings.field.rule_type_delay.unit_hours': 'Hours',
    'lvt.settings.field.rule_type_delay.before': 'Before',
    'lvt.settings.field.rule_type_delay.after': 'After',
    'lvt.settings.field.rule_type_atrisk.percentage': 'Percentage threshold',
    'lvt.settings.field.schedule_date_priority': 'Schedule date priority',
    'lvt.settings.field.schedule_date_priority.booking_time': 'Booked timeslot',
    'lvt.settings.field.schedule_date_priority.planned_earliest_arrival': 'Earliest planned arrival',
    'lvt.settings.field.schedule_date_priority.planned_latest_arrival': 'Latest planned arrival',
    'lvt.settings.field.error.required': 'is required',

    // popup
    'lvt.popup.yes': 'Yes',
    'lvt.popup.cancel': 'Cancel',

    // messages from backend
    'lvt.message.info_saved_successfully': 'Info saved successfully.',
    'lvt.message.info_updated_successfully': 'Info updated successfully.',
    'lvt.message.info_deleted_successfully': 'Info deleted successfully.',
    'lvt.message.warn': 'Warning: ',
    'lvt.message.error': 'Error: ',
    'lvt.message.error_no_name_specified': 'No name specified.',
    'lvt.message.error_no_company_id_specified': 'No company Id specified.',
    'lvt.message.error_no_location_type_specified': 'No location type specified.',
    'lvt.message.error_no_rule_type_specified': 'No rule type specified.',
    'lvt.message.error_date_priorities_not_specified': 'Date priorities not specified.',
    'lvt.message.error_delay_offset_not_specified': 'Delay offset not specified.',
    'lvt.message.error_at_risk_offset_not_specified': 'At risk offset not specified.',
    'lvt.message.error_no_entity_found': 'No entity found.',
    'lvt.message.error_could_not_convert_delay_rule': 'Could not convert delay rule.',

    // search
    'lvt.order_list.search': 'Search'
};



// WEBPACK FOOTER //
// ./src/app/services/translation/lang/lang-fr.ts